import { Box, Button, Divider, Drawer, Fab, Grid, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AnimateButton from 'ui-component/extended/AnimateButton'
import { IconActivity } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NotificationList from 'layout/MainLayout/Header/NotificationSection/NotificationList';
import axiosInstance from 'custom-axios';
import RefreshIcon from '@mui/icons-material/Refresh';
// import axiosInstance from 'custom-axios';

const ClientFormActivity = ({ called_from, userId }) => {

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    const [notificationData, setNotificationData] = useState([]);

    const fetchClientActivity = async () => {
        try {
            const response = await axiosInstance.get(`api/client-activity/${userId}`);
            if (response.success) {
                setNotificationData(response.data);
            }
        } catch (error) {
            // console.error(error.message);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchClientActivity();
        }
    }, [userId]);

    const handleRefreshActivity = async () => {
        await fetchClientActivity();
    }

    const handleToggle = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen(!open);
    };

    return (
        <>
            <Tooltip title="Client Activity">
                <Fab
                    component="div"
                    onClick={handleToggle}
                    size="medium"
                    variant="circular"
                    color="secondary"
                    sx={{
                        backgroundColor: '#124734',
                        borderRadius: 0,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        borderTopRightRadius: '50%',
                        borderBottomRightRadius: '4px',
                        top: '25%',
                        position: 'fixed',
                        right: 10,
                        zIndex: theme.zIndex.speedDial
                    }}
                >
                    <AnimateButton type="rotate">
                        <IconButton color="inherit" size="large" disableRipple>
                            <IconActivity />
                        </IconButton>
                    </AnimateButton>
                </Fab>
            </Tooltip>

            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    // sx: {
                    //     width: '20%',
                    //     paddingTop: called_from == 'client' ? '70px' : ''
                    // }
                    sx: {
                        paddingTop: called_from == 'client' ? '70px' : '',
                        width: {
                            xs: '100%',   // Mobile
                            sm: 420,      // Small tablets
                            // md: 520,      // Laptops
                            // lg: 600       // Large desktops
                        }
                    }
                }}
            >
                <PerfectScrollbar component="div"> {/*  set width for inner content  */}
                    <Paper sx={{ marginLeft: 0 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" justifyContent="space-between" sx={{ padding: '20px', marginLeft: '5px', marginTop: '3px' }}>
                                    <Grid item>
                                        <Stack direction="row" spacing={2}>
                                            <Box
                                                sx={{
                                                    width: 4,
                                                    height: 25,
                                                    backgroundColor: theme.palette.primary.main
                                                }}
                                            />
                                            <Typography variant="subtitle1" className='font14px'><strong>Client Activity</strong></Typography>

                                            {/* {notificationData.length > 0 &&
                                                <Chip
                                                    size="small"
                                                    label={notificationData.length}
                                                    sx={{
                                                        color: theme.palette.background.default,
                                                        bgcolor: theme.palette.warning.dark
                                                    }}
                                                />
                                            } */}
                                        </Stack>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="text"
                                            color="primary"
                                            size="small"
                                            startIcon={<RefreshIcon />}
                                            onClick={handleRefreshActivity}
                                            sx={{ textTransform: 'none', fontWeight: 600 }}
                                        >
                                            Refresh
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} className='padding-top0px'>
                                <PerfectScrollbar className='ps-full-height'>

                                    <Grid item xs={12} p={0}>
                                        <Divider sx={{ my: 0 }} className='divider' />
                                    </Grid>

                                    <NotificationList userId={userId} notificationData={notificationData} />

                                </PerfectScrollbar>
                            </Grid>

                            {/* <Divider />
                            <Grid container justifyContent="center">
                                <CardActions sx={{ p: 1.25 }}>
                                    <Button size="small" disableElevation>
                                        View All
                                    </Button>
                                </CardActions>
                            </Grid> */}
                        </Grid>
                    </Paper>
                </PerfectScrollbar>
            </Drawer>
        </>
    )
}

export default ClientFormActivity